import api from '../../api'

// Utilities
import Logger from '../../utility/loggerUtil'
import { LIST_OF_STATES } from '../../constants.js'

export default {
  async getPredictions (context, params) {
    try {
      const response = await api.address.getPredictions(params)
      context.commit('setPredictions', response.predictions)
      return response.predictions
    } catch (e) {
      Logger.error('Error getting address predictions')
      Logger.debug(e)
      throw e
    }
  },

  async getPlaceDetails (context, params) {
    try {
      const response = await api.address.getPlaceDetails(params)
      context.commit('setPlaceDetails', response.details)
      return response.details
    } catch (e) {
      Logger.error('Error getting place details')
      Logger.debug(e)
      throw e
    }
  },

  clearAutocompleteData (context) {
    context.commit('clearPredictions')
    context.commit('clearPlaceDetails')
  },

  async getCityStateFromZipCode (context, params) {
    try {
      const response = await api.address.getCityStateFromZip(params)
      const responseState = response?.stateName ? LIST_OF_STATES.find(element => element.text.toLowerCase() === response.stateName.toLowerCase())?.value : response.state
      return {
        state: responseState,
        city: response?.placeName,
        message: response?.message
      }
    } catch (e) {
      Logger.error('Error getting place details')
      Logger.debug(e)
      throw e
    }
  }
}
